import React, { useContext, useEffect, useState } from "react";
import { Button, Dropdown, Form, OverlayTrigger } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { BiDownload, BiPencil, BiTransfer, } from "react-icons/bi";
import { BsLayoutSplit, BsFilter} from "react-icons/bs";
import { toast } from "react-toastify";
import { LoaderContext } from "../../../../App";
import { DATA_VIEW_IMPORT_POLLING_INTERVAL } from "../../../../core/constants/common";
import KPIService from "../../../../core/service/KPIService";
import '../DataView.scss';
import Utils from "../../../../core/utilities/Utils";
import { AiOutlineApartment } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import StandardService from "../../../../core/service/StandardService";

let importStatusPoller;

const CompareHeader = ({
    t,
    filter,
    regulationId,
    onFilterClick,
    onColHideShow
}) => {

    const { setLoaderDisplay } = useContext(LoaderContext);
    const [importInProgress, setImportInProgress] = useState(false);
    const [colHideShow, setColHideShow] = useState({
        codes: true,
        uom: true
    });
    const navigate = useNavigate();

    useEffect(() => {
        fetchImportStatus(true);
        return () => {
            // On unmounting
            clearImportStatusPoller();
        };
    }, []);

    useEffect(() => {
        onColHideShow(colHideShow);
    }, [colHideShow]);

    const onExport = () => {
        setLoaderDisplay(true);
        StandardService.exportCompareData(filter)
            .then((response) => {
                setLoaderDisplay(false);
                let blob = new Blob([response.data], { type: 'application/json' });
                const fileURL = window.URL.createObjectURL(blob);
                let link = document.createElement('a');
                link.href = fileURL;
                link.download = `Comparison.xlsx`;
                link.click();
                link.remove();
            })
            .catch((error) => {
                setLoaderDisplay(false);
                toast.error(error.message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            });
    };

    const onFileSelect = (e) => {
        e.preventDefault();
        const fileUploaded = e.target.files[0];
        importFile(fileUploaded);
    };

    const importFile = (file) => {
        const formData = new FormData();
        formData.append("file", file);
        setLoaderDisplay(true);
        KPIService.uploadFile(formData, regulationId, filter.reportingPeriod)
            .then((response) => {
                toast.success(response.data, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setImportInProgress(true);
                fetchImportStatus(true);
            })
            .catch((error) => {
                setLoaderDisplay(false);
            })
            .finally(() => {
                setLoaderDisplay(false);
            });
    };

    const fetchImportStatus = (startPoller = false) => {
        KPIService.getImportStatus().then(res => {
            if (res.data.data) {
                setImportInProgress(true);
                if (!startPoller) return;

                startImportStatusPoller();
            } else {
                clearImportStatusPoller();
            }
        }).catch(err => {
            clearImportStatusPoller();
        });
    };

    const startImportStatusPoller = () => {
        importStatusPoller = setTimeout(function request() {
            fetchImportStatus();
            importStatusPoller = setTimeout(request, DATA_VIEW_IMPORT_POLLING_INTERVAL);
        }, DATA_VIEW_IMPORT_POLLING_INTERVAL);
    };

    const clearImportStatusPoller = () => {
        setImportInProgress(false);
        if (!importStatusPoller) return;

        clearTimeout(importStatusPoller);
    };

    const [isActive, setIsActive] = useState(false);

    const handleClick = () => {
        setIsActive(!isActive); // Toggle the active state
        onFilterClick(); // Call the provided function
    };

    const onDownloadDocuments = () => {
        const date = new Date(filter.reportingPeriod);
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        let categoryType = '';
        if (filter.categoryType === 0) {
            categoryType = 'ENVIRONMENTAL';
        } else if (filter.categoryType === 1) {
            categoryType = 'SOCIAL';
        } else if (filter.categoryType === 2) {
            categoryType = 'GOVERNANCE';
        }
        setLoaderDisplay(true);
        KPIService.exportMetricDataAttachments(regulationId, filter.reportingPeriod, filter.businessUnitIds, filter.topicIds, categoryType)
            .then((response) => {
                setLoaderDisplay(false);
                let blob = new Blob([response.data], { type: 'application/octet-stream' });
                const fileURL = window.URL.createObjectURL(blob);
                let link = document.createElement('a');
                link.href = fileURL;
                link.download = `attachments-${month}-${year}.zip`;
                link.click();
                link.remove();
            })
            .catch(async (error) => {
                setLoaderDisplay(false);
                const blobToText = await error.response.data.text();
                const textToJson = JSON.parse(blobToText);
                toast.error(textToJson.message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            });
    };

    const gotoDataView = () => {
		navigate({
			pathname: "/company_admin/dataview",
		});
	}

    return (
        <div className="header-actions">
            

            <OverlayTrigger
                placement="top"
                overlay={Utils.renderTooltip(
                    t("Filter.label")
                )}>
                <button
                    // ${isActive ? 'btn-headbtn' : 'btn-headbtn active'}
                    className="btn btn-headbtn"
                    onClick={handleClick}
                >
                    <BsFilter />
                </button>
            </OverlayTrigger>

            <OverlayTrigger
                placement="top"
                overlay={Utils.renderTooltip(
                    t("ShowColumns.label")
                )}>
                <Dropdown>
                    <Dropdown.Toggle variant="headbtn" id="dropdown-basic">
                        <BsLayoutSplit />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="CustomizeColumns_drop p-2">
                        <div className="p-2">
                            <h6 className="mb-0">{t("ShowColumns.label")}</h6>
                        </div>
                        <ul>
                            <li>
                                <Form.Check
                                    inline
                                    name="group1"
                                    label="Code"
                                    type="checkbox"
                                    id="inline-checkbox-1"
                                    checked={colHideShow.codes}
                                    onChange={() => setColHideShow({ ...colHideShow, codes: !colHideShow.codes })}
                                />
                            </li>
                            <li>
                                <Form.Check
                                    inline
                                    name="group1"
                                    label="UOM"
                                    type="checkbox"
                                    id="inline-checkbox-2"
                                    checked={colHideShow.uom}
                                    onChange={() => setColHideShow({ ...colHideShow, uom: !colHideShow.uom })}
                                />
                            </li>
                        </ul>
                    </Dropdown.Menu>
                </Dropdown>
            </OverlayTrigger>

            <OverlayTrigger
                placement="top"
                overlay={Utils.renderTooltip(
                    t("Download.label")
                )}>
                <Button variant="headbtn"
                    onClick={() => {onExport()}}
                    className="sbmBtn">
                    <BiDownload />
                </Button>
            </OverlayTrigger>
            <OverlayTrigger
                placement="top"
                overlay={Utils.renderTooltip(
                    t("Periodic.label")
                )}>
                <Button variant="headbtn"
                    onClick={() => {gotoDataView()}}
                    className="sbmBtn">
                    <AiOutlineApartment />
                </Button>
            </OverlayTrigger>
        </div>
    );
};

export default withTranslation()(CompareHeader);
